<template>
  <div class="flex animate-pulse flex-col gap-4 md:gap-6">
    <div
      v-for="item in 2"
      :key="item + 'block'"
      class="scrollbar-hidden flex gap-2 overflow-x-scroll md:gap-4 lg:grid lg:grid-cols-5"
    >
      <SeanceCardSkeleton v-for="item in 4" :key="item + 'card'" class="min-w-2/3 lg:min-w-px" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { SeanceCardSkeleton } from '@/5_entities/Seance'

defineProps({
  count: {
    type: Number,
    required: false,
    default: 5
  }
})
</script>
